import { useEffect, useState, useCallback } from 'react'

interface UseImageLoaderProps {
  src: string
}

interface UseImageLoaderReturn {
  isLoaded: boolean
  imageSrc: string
}

export const useImageLoader = ({
  src,
}: UseImageLoaderProps): UseImageLoaderReturn => {
  const [imageSrc, setImageSrc] = useState(src)
  const [isLoaded, setIsLoaded] = useState(false)

  const onLoad = useCallback(() => {
    setIsLoaded(true)
  }, [isLoaded])

  useEffect(() => {
    let img: HTMLImageElement | null
    if (imageSrc) {
      setIsLoaded(false)
      img = new Image()
      img.addEventListener('load', onLoad)
      img.src = imageSrc
    }
    return (): void => {
      if (img) {
        img.removeEventListener('load', onLoad)
      }
    }
  }, [imageSrc])

  useEffect(() => {
    setImageSrc(src)
  }, [src])

  return {
    isLoaded,
    imageSrc,
  }
}
